import styled from "styled-components";

export const StyledCashFlowProfitWrapper = styled.div``;

export const StyledCashFlowProfitListItem = styled.div`
  border-top: 1px solid #E5E5E5;
  &:last-child {
    border-bottom: 1px solid #E5E5E5;
  }
  
  .profit-list-table {
    &__row {
      border: none;
    }
  }
  .active {
    color: #277661;
    background-color: #F5F4FA;
    border-bottom: 1px solid #E5E5E5;
  }
`;

export const StyledCashFlowProfitDetailsWrapper = styled.div`
  margin-left: 40px;
  border-left: 1px solid #E5E5E5;

  .service-profit-table {
    margin-bottom: 0;
    &__head, &__row {
      padding: 20px;
      grid-template-columns: minmax(0, 350px) 1fr;
    }
    &__row {
      &:last-child {
        border-bottom: none;
      }
    }
  }
`;

export const StyledAboutOfProfit = styled.div`
  padding: 2px 8px;
  color: ${({ color }) => color === "green" ? "#1e4620" : color === "red" ? "#5f2120" : "#5e5e5e"};
  font-weight: 600;
  background-color: ${({ color }) => color === "green" ? "#edf7ed" : color === "red" ? "#fdeded" : "#f5f5f5"};
  border-radius: 5px;
`;